import { createI18n } from 'vue-i18n';
import { useThemeConfig } from '@/composables/useThemeConfig';

const { locale } = useThemeConfig();

const messages = Object.fromEntries(
  Object.entries(import.meta.glob('./locales/*.json', { eager: true })).map(([key, value]) => [key.slice(10, -5), value.default]),
);

export default createI18n({
  legacy: false,
  locale: locale.value || 'en',
  fallbackLocale: 'en',
  messages,
});
